import React from 'react';
import { Button, Space, Tag } from 'antd';
import {
  CrownOutlined,
  CheckCircleOutlined,
  HomeOutlined,
  LoginOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import './ModuleAccessGuide.css';

const STATUS_COPY = {
  anonymous: {
    tag: '需要登录',
    title: '请先登录',
    desc: '登录后才能查看该业务的个人数据和会员状态。',
    primaryIcon: <LoginOutlined />,
  },
  not_opened: {
    tag: '未开通',
    title: title => `尚未开通${title}`,
    desc: title => `开通后即可进入${title}，使用对应的数据记录、统计和管理功能。`,
    primaryIcon: <CrownOutlined />,
  },
  expired: {
    tag: '已过期',
    title: title => `${title}服务已过期`,
    desc: (title, expiredAt) => {
      const dateText = expiredAt ? `，到期时间为 ${expiredAt}` : '';
      return `续费后可继续进入${title}，历史数据会保留${dateText}。`;
    },
    primaryIcon: <ReloadOutlined />,
  },
};

export default function ModuleAccessGuide({ access, onLogin, onPay, onHome }) {
  const copy = STATUS_COPY[access?.status] || STATUS_COPY.not_opened;
  const title = access?.title || '该业务';
  const heading = typeof copy.title === 'function' ? copy.title(title) : copy.title;
  const desc = typeof copy.desc === 'function' ? copy.desc(title, access?.expiredAt) : copy.desc;
  const primaryText = access?.actionText || (access?.status === 'expired' ? '立即续费' : '立即开通');
  const primaryAction = access?.status === 'anonymous' ? onLogin : onPay;
  const showBusinessValue = access?.status === 'expired' || access?.status === 'not_opened';
  const valuePoints = access?.valuePoints || [];

  return (
    <div className="sj-access-guide">
      <div className="sj-access-guide-inner">
        <Tag className={`sj-access-guide-tag sj-access-guide-tag-${access?.status || 'not_opened'}`}>
          {copy.tag}
        </Tag>
        <h2>{heading}</h2>
        <p>{desc}</p>
        {showBusinessValue && (
          <div className="sj-access-guide-value">
            <div className="sj-access-guide-value-header">
              <SafetyCertificateOutlined />
              <div>
                <h3>{access?.valueTitle || `为什么继续使用${title}`}</h3>
                <p>{access?.valueDesc || `续费后可以恢复${title}相关功能，并继续查看和维护已有数据。`}</p>
              </div>
            </div>
            {valuePoints.length > 0 && (
              <div className="sj-access-guide-points">
                {valuePoints.map(point => (
                  <div className="sj-access-guide-point" key={point}>
                    <CheckCircleOutlined />
                    <span>{point}</span>
                  </div>
                ))}
              </div>
            )}
            {access?.status === 'expired' && (
              <div className="sj-access-guide-status">
                <span>当前状态：已过期</span>
                {access?.startedAt && <span>开始时间：{access.startedAt}</span>}
                {access?.expiredAt && <span>到期时间：{access.expiredAt}</span>}
              </div>
            )}
          </div>
        )}
        <Space size={12} wrap>
          <Button
            type="primary"
            size="large"
            icon={copy.primaryIcon}
            onClick={primaryAction}
          >
            {primaryText}
          </Button>
          <Button
            size="large"
            icon={<HomeOutlined />}
            onClick={onHome}
          >
            返回用户中心
          </Button>
        </Space>
      </div>
    </div>
  );
}
